import Select from "react-select"
import React, { useEffect, useState } from "react"
import { getCountryOptions } from "common/SelectOptions/countryOptions"
import { getSystemOptions } from "common/SelectOptions/systemOptions"

const PublicPolicyDirectoryFilters = ({
  appliedFilters, 
  applyFilters,
}) => {
  const [locationOptions, setLocationOptions] = useState([]);
  const [systemOptions, setSystemOptions] = useState([]);
  const [filters, setFilters] = useState(appliedFilters);

  const handleChange = (options, field) => {
    setFilters((prev)=>({
      ...prev,
      [field]: options
    }))
  }

  useEffect(() => {
    const fetchOptions = async () => {
      setLocationOptions(await getCountryOptions());
      setSystemOptions(await getSystemOptions());
    };
    fetchOptions();
  }, []);

  return (
    <div>
      {/* Filter by Location */}
      <div className="mb-6">
        <div className="flex items-center mb-2">
          <i className="mdi mdi-map-marker-outline mr-1" />
          <h6 className="font-medium">Locations:</h6>
        </div>
        <div className="w-full">
          <Select
            isMulti
            options={locationOptions}
            defaultValue={filters.locations}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select locations"
            onChange={options => handleChange(options, 'locations')}
          />
        </div>
      </div>

      {/* Filter by Systems */}
      <div className="mb-6">
        <div className="flex items-center mb-2">
          <i className="mdi mdi-link-variant mr-1" />
          <h6 className="font-medium">Systems:</h6>
        </div>
        <div className="w-full">
          <Select
            isMulti
            options={systemOptions}
            defaultValue={filters.systems}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select systems"
            onChange={options => handleChange(options, 'systems')}
          />
        </div>
      </div>

      {/* Apply Filters Button */}
      <div className="flex justify-center mt-6">
        <button
          className="w-full sm:w-3/4 common-button"
          onClick={()=>applyFilters(filters)}
        >
          Apply
        </button>
      </div>
    </div>
  )
}

export default PublicPolicyDirectoryFilters
